module Meevo.ChangePassword {
    "use strict";

    export interface IChangePasswordContext {
        update(): void;
    }

    export class ChangePasswordContext implements IChangePasswordContext {

        currentPassword: string;
        newPassword: string;
        verifyPassword: string;
        allowCancel: any;
        message: any;
        showCurrent: boolean;

        constructor(private appSettings: Meevo.Components.Common.IAppSettings,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private $translate: angular.translate.ITranslateService,
            private redirectHandler: Function,
            protected model: any,
            protected userId: any,
            protected userName: any,
            protected requireChangePassword?: boolean,
            private handleRequest?: (newPassword: string) => void) {
            this.showCurrent = Model.Guard.isSomething(userId);
            this.allowCancel = (Model.Guard.isSomething(requireChangePassword)) ? requireChangePassword : !this.identityService.current().requireChangePassword;
        }

        update(): void {
            this.message = '';
            let request = {
                "userId": this.userId,
                "currentPassword": this.currentPassword,
                "newPassword": this.newPassword,
                "verifyPassword": this.verifyPassword
            };
            var endPoint = "employee";
            var user = <Model.User>this.model;
            if (this.newPassword.indexOf(this.userName) >= 0)
                this.message = this.$translate.instant("LABEL_NEW_PASSWORD_CANNOT_CONTAIN_ID");
            else if (user === null) {
                // Check new passwords match
                if (this.newPassword != this.verifyPassword) {
                    this.message = this.$translate.instant("LABEL_NEW_PASSWORD_MUST_MATCH");
                }
                // Check new password differs from existing password
                else if (this.currentPassword != this.newPassword) {

                    if (this.handleRequest && typeof this.handleRequest === 'function'){
                        this.handleRequest(this.newPassword);

                        return;
                    }

                    this.dataService.update(`${endPoint}/${this.userId}/password/`, request)
                        .then((response) => {
                            this.redirectHandler();
                        }, (reason) => {
                            this.message = reason.data.responseStatus.message;
                        });
                }
                else {
                    this.message = this.$translate.instant("LABEL_NEW_PASSWORD_CANNOT_MATCH_PREVIOUS");
                }
            }
            else {
                // Validate password when adding/editing user
                //    this.dataService.update(`${endPoint}/${this.userId}/PasswordValidate`, request)

                if (this.handleRequest && typeof this.handleRequest === 'function'){
                    this.handleRequest(this.newPassword);

                    return;
                }

                this.dataService.update(`${endPoint}/passwordvalidate`, request)
                    .then((response) => {
                        user.password = this.newPassword;
                        this.redirectHandler();
                    }, (reason) => {
                        this.message = reason.data.responseStatus.message;
                    });
            }
        }

        get submitLabel(): string {
            return Model.Guard.isSomething(this.model) ? "LABEL_APPLY" : "LABEL_OK";
        }
    }
}